import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginGuard } from '@ls-core';

import { publicWidgetRouting } from './pages/main/modules/page-widget/page-widget.routes';
import { RegistrationGuard } from './core/guards/registration.guard';

const routes: Routes = [
    {
        path: 'login', canActivate: [LoginGuard],
        loadComponent: () => import('./pages/login/login.component').then(m => m.LoginComponent),
    },
    {
        path: 'reg', canActivate: [LoginGuard, RegistrationGuard],
        loadComponent: () => import('./pages/register/register.component').then(m => m.RegisterComponent),
    },
    {
        path: 'activation', children: [
            { path: '', pathMatch: 'full', redirectTo: '/' },
            {
                path: '', canActivate: [LoginGuard],
                loadChildren: () => import('./pages/activation/activation.module').then(m => m.ActivationModule),
            },
        ],
    },
    {
        path: 'info', loadChildren: () => import('./pages/info/info.module').then(m => m.InfoModule),
    },
    {
        path: 'print', loadChildren: () => import('./pages/print-pages/print-pages.module').then(m => m.PrintPagesModule),
    },
    {
        path: 'export/public-bill', loadChildren: () => import('./pages/public-order-bill/public-order-bill.module').then(m => m.PublicOrderBillModule),
    },
    {
        path: 'export/order/:uuid/history',
        loadComponent: () => import('./pages/public-order-page/page-public-order-history/page-public-order-history.component')
            .then(m => m.PagePublicOrderHistoryComponent),
    },
    {
        path: 'export/order/:uuid',
        loadComponent: () => import('./pages/public-order-page/page-public-order/page-public-order.component').then(m => m.PagePublicOrderComponent),
    },
    {
        path: 'export/order-widget', loadChildren: () => import('./pages/public-order-widget/public-order-widget.module').then(m => m.PublicOrderWidgetModule),
    },
    {
        path: 'export/widget', children: publicWidgetRouting,
    },
    {
        path: 'example/three-js', loadChildren: () => import('./pages/example-three-js/example-three-js-routing.module')
            .then(c => c.ExampleThreeJsRoutingModule),
    },
    {
        path: '', loadChildren: () => import('./pages/main/main.module').then(m => m.MainModule),
    },
    { path: '**', redirectTo: '/' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {})],
    exports: [RouterModule],
})
export class AppRoutingModule {
}
